import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <section className="section container" style={{ textAlign: "center" }}>
      <p className="eyebrow">404</p>
      <h1 className="gradient-text">Page not found</h1>
      <p className="lede" style={{ marginInline: "auto", marginTop: "var(--space-6)", marginBottom: "var(--space-8)" }}>
        The page you're looking for doesn't exist or has moved. Let's get you back on track.
      </p>
      <Link to="/" className="btn btn--primary">Back to home</Link>
    </section>
  );
}
